import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import { CatalogAPI } from '../lib/api';

const CategoriesGrid = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    CatalogAPI.categories().then(setCategories).catch(() => {});
  }, []);

  return (
    <section className="bg-white py-12 border-t border-[#E8E0D0]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#C75B27] font-medium mb-2">Explorer</div>
            <h2 className="font-serif text-3xl lg:text-4xl font-semibold text-[#1F4D3F]">Toutes les catégories</h2>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {categories.map((c) => {
            const Icon = LucideIcons[c.icon] || LucideIcons.Package;
            return (
              <Link key={c.id} to={`/categorie/${c.id}`} className="card-hover bg-[#FAF7F2] hover:bg-white border border-[#E8E0D0] rounded-xl p-4 flex items-center gap-3 group">
                <div className="w-10 h-10 rounded-lg bg-white border border-[#E8E0D0] group-hover:bg-[#1F4D3F] group-hover:border-[#1F4D3F] flex items-center justify-center shrink-0 transition-colors">
                  <Icon className="w-5 h-5 text-[#1F4D3F] group-hover:text-white transition-colors" />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-[#2D2A26] truncate">{c.name}</div>
                  <div className="text-xs text-[#7A6F5C]">{c.count} produits</div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoriesGrid;
